import { isGlobalFeatureEnabled } from 'owa-feature-flags';

let promptForResourceEnabled = false;

export function isPromptForResourceTokenEnabled(): boolean {
    if (!promptForResourceEnabled) {
        promptForResourceEnabled = isGlobalFeatureEnabled(
            'auth-stepup-promptForResourceToken',
            false
        );
    }
    return promptForResourceEnabled;
}
